import type { DeviceType } from '@innhold/core/device/types';

const getFinnBlinkAdsToReplace = (): Array<string[]> => {
    return [
        ['board_backfill_1', 'hayabusa_board_backfill_1_front'],
        ['board_backfill_2', 'hayabusa_board_backfill_2_front'],
        ['board_backfill_3', 'hayabusa_board_backfill_3_front'],
        ['board_backfill_4', 'hayabusa_board_backfill_4_front'],
        ['netboard_backfill_1', 'hayabusa_netboard_backfill_1_front'],
        ['netboard_backfill_2', 'hayabusa_netboard_backfill_2_front'],
        ['netboard_backfill_3', 'hayabusa_netboard_backfill_3_front'],
        ['netboard_backfill_4', 'hayabusa_netboard_backfill_4_front'],
    ];
};

const getFinnBlinkSizes = (deviceType: DeviceType): { width: number; height: number } => {
    const isMobile = deviceType === 'mobile';
    if (isMobile) {
        return { width: 375, height: 250 };
    }
    return { width: 580, height: 450 };
};

export { getFinnBlinkAdsToReplace, getFinnBlinkSizes };
